import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { redirectToDashboardIfAuthGuard } from './guards/redirect-to-dashboard-if-auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'main/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then(m => m.HomePage),
    canActivate: [redirectToDashboardIfAuthGuard]
  },
  {
    path: 'register',
    loadComponent: () => import('./register/register.page').then(m => m.RegisterPage)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password.page').then(m => m.ForgotPasswordPage)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./reset-password/reset-password.page').then(m => m.ResetPasswordPage)
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./verify-email/verify-email.page').then(m => m.VerifyEmailPage)
  },
  {
    path: 'main',
    loadComponent: () => import('./main-shell/main-shell.page').then(m => m.MainShellPage),
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.page').then(m => m.DashboardPage)
      },
      {
        path: 'quotation-list',
        loadComponent: () => import('./quotation-list/quotation-list.page').then(m => m.QuotationListPage)
      },
      {
        path: 'invoice-list',
        loadComponent: () => import('./invoice-list/invoice-list.page').then(m => m.InvoiceListPage)
      },
      {
        path: 'notifications',
        loadComponent: () => import('./notifications/notifications.page').then(m => m.NotificationsPage)
      },
      {
        path: 'more',
        loadComponent: () => import('./settings/settings.page').then(m => m.SettingsPage)
      }
    ]
  },
  { path: 'dashboard', redirectTo: 'main/dashboard', pathMatch: 'full' },
  { path: 'quotation-list', redirectTo: 'main/quotation-list', pathMatch: 'full' },
  { path: 'invoice-list', redirectTo: 'main/invoice-list', pathMatch: 'full' },
  { path: 'settings', redirectTo: 'main/more', pathMatch: 'full' },
  {
    path: 'add-invoice',
    loadComponent: () => import('./add-invoice/add-invoice.page').then(m => m.AddInvoicePage),
    canActivate: [authGuard]
  },
  {
    path: 'add-invoice/:id',
    loadComponent: () => import('./add-invoice/add-invoice.page').then(m => m.AddInvoicePage),
    canActivate: [authGuard]
  },
  {
    path: 'customer-manager',
    loadComponent: () => import('./customer-manager/customer-manager.page').then(m => m.CustomerManagerPage),
    canActivate: [authGuard]
  },
  {
    path: 'item-manager',
    loadComponent: () => import('./item-manager/item-manager.page').then(m => m.ItemManagerPage),
    canActivate: [authGuard]
  },
  {
    path: 'add-quotation',
    loadComponent: () => import('./add-quotation/add-quotation.page').then(m => m.AddQuotationPage),
    canActivate: [authGuard]
  },
  {
    path: 'add-quotation/:id',
    loadComponent: () => import('./add-quotation/add-quotation.page').then(m => m.AddQuotationPage),
    canActivate: [authGuard]
  },
  {
    path: 'preview-professional/:id',
    loadComponent: () => import('./preview-professional/preview-professional.page').then(m => m.PreviewProfessionalPage),
    canActivate: [authGuard]
  },
  {
    path: 'preview-executive/:id',
    loadComponent: () => import('./preview-executive/preview-executive.page').then(m => m.PreviewExecutivePage),
    canActivate: [authGuard]
  },
  {
    path: 'preview-classic/:id',
    loadComponent: () => import('./preview-classic/preview-classic.page').then(m => m.PreviewClassicPage),
    canActivate: [authGuard]
  },
  {
    path: 'preview-invoice-classic/:id',
    loadComponent: () =>
      import('./preview-invoice-classic/preview-invoice-classic.page').then(m => m.PreviewInvoiceClassicPage),
    canActivate: [authGuard]
  },
  {
    path: 'preview-style/:id',
    loadComponent: () => import('./preview-style/preview-style.page').then(m => m.PreviewStylePage),
    canActivate: [authGuard]
  },
  {
    path: 'preview-quotation-mobile/:id',
    loadComponent: () =>
      import('./preview-quotation-mobile/preview-quotation-mobile.page').then(m => m.PreviewQuotationMobilePage),
    canActivate: [authGuard]
  },
  {
    path: 'subscription',
    loadComponent: () => import('./subscription/subscription.page').then(m => m.SubscriptionPage),
    canActivate: [authGuard]
  },
  {
    path: 'delete-account',
    loadComponent: () => import('./delete-account/delete-account.page').then(m => m.DeleteAccountPage),
    canActivate: [authGuard]
  },
  {
    path: 'payment',
    loadComponent: () => import('./payment/payment.page').then(m => m.PaymentPage),
    canActivate: [authGuard]
  },
  // Legal / info pages (website only – for Razorpay compliance)
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./legal/terms-and-conditions/terms-and-conditions.page').then(m => m.TermsAndConditionsPage)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./legal/privacy-policy/privacy-policy.page').then(m => m.PrivacyPolicyPage)
  },
  {
    path: 'shipping-policy',
    loadComponent: () => import('./legal/shipping-policy/shipping-policy.page').then(m => m.ShippingPolicyPage)
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./legal/contact-us/contact-us.page').then(m => m.ContactUsPage)
  },
  {
    path: 'cancellation-refunds',
    loadComponent: () => import('./legal/cancellation-refunds/cancellation-refunds.page').then(m => m.CancellationRefundsPage)
  }
];
